import {api, handleApiError, ServiceResponse} from "../ApiClient";

export interface ClubCaddie {
    caddieId: string;
    userId: string;
    firstName: string;
    displayName: string;
    approved: boolean;
    phoneNumber?: string;
}

export interface GetClubCaddiesResponse extends ServiceResponse {
    caddies?: ClubCaddie[]
}

export const ClubCaddieService = () => {

    const getAll = async (clubId: string): Promise<GetClubCaddiesResponse> => {
        return api.get<ClubCaddie[]>(`/api/1/club/${clubId}/caddies?onlyApproved=true`)
            .then((resp) => {
                if (resp && resp.status === 200 && resp.data) {
                    return {
                        caddies: resp.data
                    }
                }

                return {
                    error: {
                        message: 'Could not get caddies for club.'
                    }
                }
            })
            .catch(handleApiError)
    }

    return {
        getAllCaddies: getAll
    }
}
